const defaultPermissionValue = ({user, permission}) => {
  if (![null, undefined].includes(user?.[permission.permission]))
    return permission.type === 'string'
      ? `${user?.[permission.permission]}`
      : user?.[permission.permission];
  return permission.type === 'string' ? '' : false;
};

export default defaultPermissionValue;
